import $axios from "@widget/plugins/axios";

const fakeLeads = {
    namespaced: true,
    state: () => ({
        loading: true,
        data: {
            items: [],
            labels: {}
        }
    }),
    mutations: {
        setLoading (state, payload) {
            state.loading = payload;
        },
        setData (state, payload) {
            state.data = payload;
        }
    },
    getters: {
        getData: state => {
            return state.data;
        },
        getLoading: state => {
            return state.loading;
        }
    },
    actions: {
        getList ({ commit, rootGetters }) {
            $axios.post("/api/count/samples", rootGetters["widgetData/getQueryForAPI"]).then(({ data: { data: response } }) => {
                commit("setData", {
                    items: response.samples.items,
                    labels: response.samples.labels
                });
            }).finally(() => {
                commit("setLoading", false);
            });
        }
    }
};

export default fakeLeads;
